import { render, staticRenderFns } from "./SecaoDetalheModal.vue?vue&type=template&id=2fa57489&scoped=true&"
import script from "./SecaoDetalheModal.vue?vue&type=script&lang=js&"
export * from "./SecaoDetalheModal.vue?vue&type=script&lang=js&"
import style0 from "./SecaoDetalheModal.vue?vue&type=style&index=0&id=2fa57489&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa57489",
  null
  
)

export default component.exports